(function () {
  var root = document.querySelector('[id^="ps-"][data-deadline]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var lang = 'fr';
  try { lang = localStorage.getItem('ps-lang') || 'fr'; } catch (e) {}
  var deadline = new Date(root.getAttribute('data-deadline')).getTime();

  var EN = {
    nav0: 'Uses', nav1: 'How it works', nav2: 'Results', nav3: 'FAQ',
    eyebrow: 'Special effect · Car paint',
    h1: 'Make your car look like a crime scene',
    lead: 'Realistic blood splatter for your car. Built for Halloween, film and photo shoots. Washes off with water.',
    chooseHeading: 'Choose your bundle',
    tag2: 'Recommended', tag3: 'Best value',
    sub1: '1 to 2 cars depending on use', sub2: '2 to 4 cars · better price per bottle', sub3: '3 to 6 cars · the lowest price per bottle',
    unit: '470 ml bottles · prices in CAD',
    b0: '<strong>Looks real.</strong> A blood-splattered finish that sells the scene on your paint.',
    b1: '<strong>Washes off easily.</strong> Rinse with water and your paint goes back to normal.',
    b2: '<strong>Halloween, movies, special effects.</strong> Easy to apply for a dramatic horror look.',
    tr0: 'Ships the same day with Canada Post · tracking number included · estimated delivery in 48 h',
    tr1: 'Halloween guarantee: if your order (placed before October 27) doesn’t arrive before October 31, you get a 100% refund',
    tr2: 'Secure checkout',
    usesEyebrow: 'What it’s for', usesTitle: 'Three ways to scare people',
    u0t: 'Halloween', u0: 'Turn your car into the scariest thing on the street. The neighbors will talk about it.',
    u1t: 'Film and video', u1: 'Fresh-blood realism on camera for short films, music videos and creative content.',
    u2t: 'Special effects and photo', u2: 'For shoots and staged scenes that need a convincing crime scene on the bodywork.',
    howEyebrow: 'How it works', howTitle: 'Splatter. Rinse. Done.',
    s0t: 'Test', s0: 'Try a small, hidden spot on the bodywork first.',
    s1t: 'Splatter', s1: 'Apply it to build your splatters and streaks of blood.',
    s2t: 'Rinse', s2: 'Scene over? Wash it off with water and the paint goes back to normal.',
    videoCaption: 'While it’s being washed with water, the paint goes back to normal.',
    proofEyebrow: 'The proof', proofTitle: 'On real cars',
    proofSub: 'White, gray, black: the effect varies with the car’s color, the amount and how you apply it.',
    faqEyebrow: 'Questions', faqTitle: 'Before you order',
    q0: 'Will it damage my paint?', a0: 'The formula is made for vehicles: it’s safe for clear coats, non-staining and non-corrosive, and washes off with water. As a precaution, test a small, hidden spot before the full application.',
    q1: 'How do I get it off?', a1: 'Wash it off with water, with a pressure washer if you can. Watch the video: the paint goes back to normal during the wash.',
    q2: 'How many cars per bottle?', a2: 'One 470 ml bottle covers 1 to 2 cars, depending on the effect you want (a few splatters or dense coverage) and how much you apply.',
    q3: 'What are the delivery times and shipping costs?', a3: 'We ship across Canada with Canada Post, the same day you order, with a tracking number included. Estimated delivery in 48 h. Shipping is free with the 2- and 3-bottle bundles. For 1 bottle it costs $4.99. Last day to order: Tuesday, October 27 at midnight.',
    q4: 'What if my order doesn’t arrive before Halloween?', a4: 'If your order, placed before Tuesday, October 27, doesn’t arrive before October 31 according to Canada Post tracking, you get a 100% refund.',
    q5: 'Use it responsibly', a5: 'This is a decoration and special effects product. Don’t drive on public roads with a vehicle that looks like it’s been in a crash. You could alarm other road users.',
    finalTitle: 'Ready for the scariest night of the year?',
    fl0: 'Shipping', fl1: 'Returns', fl2: 'Privacy'
  };
  var UI = {
    fr: { order: 'Commander', each: ' / flacon', save: 'Économisez', giftOn: 'Cadeau débloqué : livraison offerte', giftOff: 'Cadeau à débloquer : livraison offerte', closed: 'Commandes fermées pour l’Halloween', zoom: 'Zoomer', unzoom: 'Dézoomer', top: 'Retour en haut',
      bar: function (c) { return 'Halloween : dernier jour de commande le mardi 27 octobre à minuit · il reste ' + c; },
      urg: function (c) { return 'Commandes ouvertes encore ' + c; },
      from: function (p) { return 'Flacon de 470 ml · dès ' + p + ' · livraison offerte dès 2 flacons'; },
      cd: function (d, h, m, s) { return d + ' j ' + h + ' h ' + m + ' min ' + s + ' s'; } },
    en: { order: 'Order', each: ' / bottle', save: 'Save', giftOn: 'Gift unlocked: free shipping', giftOff: 'Unlock a gift: free shipping', closed: 'Halloween orders are closed', zoom: 'Zoom in', unzoom: 'Zoom out', top: 'Back to top',
      bar: function (c) { return 'Halloween: last day to order is Tuesday, October 27 at midnight · ' + c + ' left'; },
      urg: function (c) { return 'Orders still open for ' + c; },
      from: function (p) { return '470 ml bottle · from ' + p + ' · free shipping from 2 bottles'; },
      cd: function (d, h, m, s) { return d + 'd ' + h + 'h ' + m + 'm ' + s + 's'; } }
  };
  var PACK_EN = { 1: '1 bottle', 2: '2 bottles', 3: '3 bottles' };
  var PACK_FR = {};
  $$('[data-pack-title]').forEach(function (el) { PACK_FR[el.getAttribute('data-pack-title')] = el.textContent; });

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return lang === 'en' ? '$' + v : v.replace('.', ',') + ' $';
  }
  function p2(n) { return (n < 10 ? '0' : '') + n; }

  $$('[data-i18n]').forEach(function (el) { el.setAttribute('data-fr', el.innerHTML); });

  function applyLang() {
    document.documentElement.setAttribute('lang', lang);
    $$('[data-i18n]').forEach(function (el) {
      var k = el.getAttribute('data-i18n');
      el.innerHTML = (lang === 'en' && EN[k] !== undefined) ? EN[k] : el.getAttribute('data-fr');
    });
    $$('[data-lang]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-lang') === lang); });
    $$('[data-pack-title]').forEach(function (el) {
      var q = el.getAttribute('data-pack-title');
      el.textContent = lang === 'en' ? (PACK_EN[q] || el.textContent) : (PACK_FR[q] || el.textContent);
    });
    var t = $('[data-totop]'); if (t) t.setAttribute('aria-label', UI[lang].top);
    renderPacks(); tick();
  }

  function selectedPack() { var i = $('[data-pack] input:checked'); return i ? i.closest('[data-pack]') : null; }

  function renderPacks() {
    var first = $$('[data-pack]')[0];
    var base = first ? +first.getAttribute('data-cents') : 0;
    $$('[data-pack]').forEach(function (p) {
      var qty = +p.getAttribute('data-qty'), cents = +p.getAttribute('data-cents');
      var single = base * qty, save = single - cents;
      p.classList.toggle('on', p.querySelector('input').checked);
      var u = p.querySelector('[data-unit]');
      if (u) u.textContent = money(Math.round(cents / qty)) + UI[lang].each + (save > 0 ? ' · ' + UI[lang].save + ' ' + money(save) : '');
      p.querySelector('[data-now]').textContent = money(cents);
      var w = p.querySelector('[data-was]'); if (w) w.textContent = money(single);
      var g = p.querySelector('[data-gift]'); if (g) g.textContent = p.querySelector('input').checked ? UI[lang].giftOn : UI[lang].giftOff;
    });
    var sel = selectedPack();
    var label = UI[lang].order + (sel ? ' — ' + money(+sel.getAttribute('data-cents')) : '');
    var cta = $('[data-cta]'); if (cta) cta.textContent = label;
    var cf = $('[data-cta-final]'); if (cf) cf.textContent = label;
    var fs = $('[data-final-sub]'); if (fs && first) fs.textContent = UI[lang].from(money(base));
  }

  function tick() {
    var diff = Math.max(0, deadline - Date.now());
    var closed = diff === 0;
    var d = Math.floor(diff / 86400000), h = Math.floor(diff % 86400000 / 3600000), m = Math.floor(diff % 3600000 / 60000), s = Math.floor(diff % 60000 / 1000);
    var c = UI[lang].cd(d, p2(h), p2(m), p2(s));
    var bar = $('[data-bar]'), urg = $('[data-urg]');
    if (bar) bar.textContent = closed ? UI[lang].closed : UI[lang].bar(c);
    if (urg) urg.textContent = closed ? UI[lang].closed : UI[lang].urg(c);
    $$('.cta,[data-cta-final]').forEach(function (b) { if (closed) b.setAttribute('disabled', 'disabled'); else b.removeAttribute('disabled'); });
  }

  $$('[data-pack] input').forEach(function (i) { i.addEventListener('change', renderPacks); });
  var fin = $('[data-buy-now]');
  if (fin) fin.addEventListener('click', function () { var f = $('.ps-form'); if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } });

  var menu = $('[data-menu]'), mbtn = $('[data-menu-btn]');
  function closeMenu() { menu.classList.remove('open'); mbtn.setAttribute('aria-expanded', 'false'); }
  mbtn.addEventListener('click', function (e) { e.stopPropagation(); var o = menu.classList.toggle('open'); mbtn.setAttribute('aria-expanded', o ? 'true' : 'false'); });
  document.addEventListener('click', function (e) { if (!menu.contains(e.target)) closeMenu(); });
  menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function (e) {
    var href = a.getAttribute('href'); if (href && href.charAt(0) === '#') { e.preventDefault(); var t = document.getElementById(href.slice(1)); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    closeMenu(); }); });
  $$('[data-lang]').forEach(function (b) { b.addEventListener('click', function () {
    lang = b.getAttribute('data-lang'); try { localStorage.setItem('ps-lang', lang); } catch (e) {} applyLang(); }); });

  var track = $('[data-track]'), thumbs = $$('[data-thumbs] button'), cur = 0;
  function mark(i) { cur = i; thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
    var tb = thumbs[i]; var box = tb && tb.parentNode; if (box && tb.offsetLeft) box.scrollTo({ left: Math.max(0, tb.offsetLeft - 80), behavior: 'smooth' }); }
  if (track) {
    var raf = null;
    track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; var i = Math.round(track.scrollLeft / (track.clientWidth || 1)); if (i !== cur) mark(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); mark(i); }); });
  }

  var top = $('[data-totop]');
  window.addEventListener('scroll', function () { top.classList.toggle('show', (window.pageYOffset || document.documentElement.scrollTop) > 500); }, { passive: true });
  top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  var tiles = $$('[data-bento] .tile'), lb = $('[data-lb]'), view = $('[data-lb-view]'), img = $('[data-lb-img]'), zb = $('[data-lb-zoom]'), idx = 0;
  function show(i) { idx = (i + tiles.length) % tiles.length; var t = tiles[idx];
    img.src = t.getAttribute('data-full'); img.alt = t.getAttribute('data-cap');
    $('[data-lb-cap]').textContent = t.getAttribute('data-cap') + ' · ' + (idx + 1) + ' / ' + tiles.length;
    view.classList.remove('z'); zb.textContent = UI[lang].zoom; }
  function open(i) { show(i); lb.classList.add('open'); document.documentElement.style.overflow = 'hidden'; }
  function close() { lb.classList.remove('open'); document.documentElement.style.overflow = ''; }
  tiles.forEach(function (t, i) { t.addEventListener('click', function () { open(i); }); });
  $('[data-lb-close]').addEventListener('click', close);
  $('[data-lb-prev]').addEventListener('click', function () { show(idx - 1); });
  $('[data-lb-next]').addEventListener('click', function () { show(idx + 1); });
  function toggleZoom() { var z = view.classList.toggle('z'); zb.textContent = z ? UI[lang].unzoom : UI[lang].zoom; }
  zb.addEventListener('click', toggleZoom); img.addEventListener('click', toggleZoom);
  document.addEventListener('keydown', function (e) { if (!lb.classList.contains('open')) return;
    if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') show(idx - 1); else if (e.key === 'ArrowRight') show(idx + 1); });

  applyLang();
  setInterval(tick, 1000);
})();